module.exports = __webpack_public_path__ + "static/media/2 valhalla angel warrior gates of female portrait .1280x1601.a864fd5f.webp";